class StickyHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollOffset = 10
    this.headerHeight = this.getHeaderHeight()
    this.setHeaderVisibility()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  getHeaderHeight () {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bao-header-height'), 10)
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setHeaderVisibility()
  }

  setHeaderVisibility () {
    /*
      This approach lets us update the attribute and re-run this method
      from ABTasty resulting in the header always being visible.
    */
    const shouldToggle = this.dataset.shouldToggle === 'true'
    if (!shouldToggle) {
      document.body.classList.add('hd-Header-visible')
      return
    }

    const currentScrollY = window.scrollY
    const scrollDown = currentScrollY > this.lastScrollY
    const nearTop = currentScrollY < this.headerHeight * 2

    const scrollUp = this.lastScrollY - currentScrollY > this.scrollOffset

    if (nearTop || scrollUp) {
      document.body.classList.add('hd-Header-visible')
    } else if (scrollDown) {
      document.body.classList.remove('hd-Header-visible')
    }

    this.lastScrollY = currentScrollY
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
